import { DARK_GRADIENT, LIGHT_GRADIENT } from "@/components/backgrounds/gradient-constants";
import type { FC } from "react";
import quoteAvatar from "@/assets/quote-avatar-int32max.jpg";

const QUOTE_TEXT = "This is one of the best agentic dev environments I've seen.";
const QUOTE_AUTHOR = "@int32max";
const QUOTE_SOURCE_URL = "https://x.com/int32max/status/2015746656994529535?s=46&t=kxtQ0kBUyk4CAnRcMsPqkg";

export const LoginQuotePanel: FC = () => {
    return (
        <div className="relative flex h-full w-full items-center justify-center p-16">
            <div className="absolute inset-0 dark:hidden" style={{ background: LIGHT_GRADIENT }} />
            <div className="absolute inset-0 hidden dark:block" style={{ background: DARK_GRADIENT }} />
            <figure className="relative flex max-w-lg flex-col items-start gap-6">
                {/* Decorative opening quote mark — absolutely positioned, hanging above the quote */}
                <div className="absolute -left-11 -top-12 z-0 select-none" aria-hidden="true">
                    <span className="text-[160px] leading-none text-white/30">&ldquo;</span>
                </div>

                <blockquote className="relative z-10 text-2xl leading-relaxed text-black dark:text-white md:text-3xl">
                    {QUOTE_TEXT}
                </blockquote>

                <figcaption>
                    <a
                        href={QUOTE_SOURCE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-3 transition-opacity hover:opacity-80"
                    >
                        <img
                            src={quoteAvatar}
                            alt={QUOTE_AUTHOR}
                            className="size-10 rounded-full border border-black/20 object-cover dark:border-white/20"
                        />
                        <span className="text-base font-medium text-black dark:text-white">{QUOTE_AUTHOR}</span>
                    </a>
                </figcaption>
            </figure>
        </div>
    );
};
